import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from '../../core/api.service';
import { UtilityService } from '../../core/global/utility.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.sass']
})
export class SidebarComponent implements OnInit {
  public currentUrl;
  usertype
  sidebarList: any = {};
  isShown;
  show: boolean = true;
  constructor(private router: Router, private _adminService: ApiService, private _utility: UtilityService) {
    this.router.events.subscribe((res) => {
      this.currentUrl = this.router.url;
    })
  }

  ngOnInit(): void {
    this.usertype = localStorage.getItem('m_ind_type');
    switch (this.usertype) {
      case '1':
        this.usertype = "user";
        break;
      case '2':
        this.usertype = "plantadmin";
        break;
      case '3':
        this.usertype = "orgadmin";
        break;
      case '4':
        this.usertype = "plantsadmin";
        break;
      case '5':
        this.usertype = "safetyofficer";
        break;
    }
    // this.getSideBar();
    setInterval(() => {
      this.getdata();
    }, 180);
    this.getdata

  }
  getdata() {
    if (this.isShown != null) {
      this.show = true
    } else {
      this.show = false
    }
    this.isShown = localStorage.getItem('isShown');
  }
  getSideBar() {
    let url = "org/limit/details";
    let data = {};
    this._adminService.post(url, data).subscribe((response) => {
      if (response.status == 200) {
        if (response.data[0] != undefined || response.data[0] != null) {
          this.sidebarList.issue = response.data[0].issue_selected;
          this.sidebarList.issue2 = response.data[0].observation2_selected;
          this.sidebarList.checklist = response.data[0].checklist_selected;
          this.sidebarList.sd = response.data[0].sd_selected;
          this.sidebarList.work_permit = response.data[0].work_permit_selected;
          this.sidebarList.lms = response.data[0].lms_selected;
          this.sidebarList.accident_selected = response.data[0].accident_selected;
          this.sidebarList.eptw_permit_selected = response.data[0].eptw_permit_selected;
          localStorage.setItem('observation2', response.data[0].observation2_selected);
          localStorage.setItem('selectedItem', JSON.stringify(response.data[0]));
        }
      } else {
        this._utility.toastError(response.message)
      }
    })
  }
}
